(function () {
  function applyPromoProductLayoutClasses() {
    if (!document.querySelector('.promo-page')) return;

    var main = document.getElementById('main-content');
    if (main) {
      main.classList.add('products', 'buy');
    }

    var wrap = document.querySelector('#main-content .main-wrap');
    if (wrap) {
      wrap.classList.add('products', 'buy');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPromoProductLayoutClasses);
  } else {
    applyPromoProductLayoutClasses();
  }

  document.addEventListener('shopify:section:load', applyPromoProductLayoutClasses);
})();
